import React from 'react';

export const Header: React.FC = () => {
    return (
        <header>

        </header>
    );
};
